import { useEffect } from 'react'
import Hero from './Home/Hero'
import About from './Home/About'
import Vision from './Home/Vision'
import CoreValues from './Home/CoreValues'
import { useData } from '../contexts/DataContext';
import { useLanguage } from '../contexts/LanguageContext';
import { useTranslation } from 'react-i18next';
import AOS from 'aos'
import 'aos/dist/aos.css'
import '../styles/rtl.css'
import '../locales/i18n';

function Home() {
  const { t } = useTranslation();
  const { language, updateDocumentTitle } = useLanguage();
  const result = useData();
  const { site_info, navigation, contact_info, social_media } = result.data;
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true
    })
  }, [])


  updateDocumentTitle("", site_info);

  return (
    <>
      <Hero />
      <section id="about">
      <About />
      <Vision />
      {/* <Mission /> */}
      <CoreValues />
      </section>
    </>
  )
}
export default Home

